import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page"
  }, [_c("template", {
    slot: "header"
  }, [_c("el-page-header", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      content: "《 " + _vm.current.name + " 》 控制器检测参数列表"
    },
    on: {
      back: _vm.back
    }
  }), _c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "代码、名称"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入代码、名称"
    },
    model: {
      value: _vm.searchForm.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "searchKey", $$v);
      },
      expression: "searchForm.searchKey"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "检测项分组"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入检测项分组"
    },
    model: {
      value: _vm.searchForm.typeGroup,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "typeGroup", $$v);
      },
      expression: "searchForm.typeGroup"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "检测项分组"
    }
  }, _vm._l(_vm.typeCategory, function (item, key) {
    return _c("el-radio", {
      key: key,
      attrs: {
        label: key
      },
      model: {
        value: _vm.searchForm.typeCategory,
        callback: function callback($$v) {
          _vm.$set(_vm.searchForm, "typeCategory", $$v);
        },
        expression: "searchForm.typeCategory"
      }
    }, [_vm._v(_vm._s(item))]);
  }), 1), _c("el-form-item", {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.search
    }
  }, [_c("i", {
    staticClass: "fa fa-search"
  }), _vm._v(" 查询")]), _vm.buttonPerms(_vm.$route.path + ":item:add") ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.add
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加")]) : _vm._e()], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.buttonPerms(_vm.$route.path + ":item:edit") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row.id);
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":item:del") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.del(scope.row.id);
            }
          }
        }, [_vm._v("删除")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "slave",
      label: "从机",
      sortable: "custom",
      width: "80"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "typeName",
      label: "项目名称",
      "min-width": "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "typeCode",
      label: "项目代码",
      "min-width": "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "typeGroup",
      label: "项目分组",
      "min-width": "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "typeCategory",
      label: "检测项目类别",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(_vm.typeCategory[scope.row.typeCategory]))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "unit",
      label: "计量单位",
      width: "80"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "valueType",
      label: "值类型",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.valueType == "Integer" ? _c("div", [_vm._v("整数")]) : _vm._e(), scope.row.valueType == "Long" ? _c("div", [_vm._v("长整形")]) : _vm._e(), scope.row.valueType == "Float" ? _c("div", [_vm._v("浮点数")]) : _vm._e(), scope.row.valueType == "String" ? _c("div", [_vm._v("字符串")]) : _vm._e(), scope.row.valueType == "Integer_Offset" ? _c("div", [_vm._v("整数偏移")]) : _vm._e(), scope.row.valueType == "Enums" ? _c("div", [_vm._v("值枚举")]) : _vm._e(), scope.row.valueType == "Number" ? _c("div", [_vm._v("数值型")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "valueMultiply",
      label: "倍增量",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.valueType != "String" && scope.row.valueType != "Enums" ? _c("div", [_vm._v(_vm._s(scope.row.valueMultiply || "-"))]) : _c("div", [_vm._v("-")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "valueOffset",
      label: "偏移量",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.valueType != "String" && scope.row.valueType != "Enums" ? _c("div", [_vm._v(_vm._s(scope.row.valueOffset || "-"))]) : _c("div", [_vm._v("-")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "取值位置",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.interactiveProtocol == "Modbus_RTU" ? _c("div", [_vm._v("( " + _vm._s(scope.row.valueStartLocation) + " - " + _vm._s(scope.row.valueEndLocation) + " ]")]) : _vm._e(), scope.row.interactiveProtocol == "JSON" ? _c("div", [_vm._v(_vm._s(scope.row.valuePath))]) : _vm._e()];
      }
    }])
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.searchForm.page,
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  }), _c("el-dialog", {
    attrs: {
      visible: _vm.editDialogShow,
      title: _vm.editDialogTitle,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialogShow = $event;
      },
      close: function close($event) {
        return _vm.initFormData(_vm.emptyFormData);
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "项目名称",
      "label-width": _vm.formLabelWidth,
      prop: "typeName"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入项目名称"
    },
    model: {
      value: _vm.formData.typeName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "typeName", $$v);
      },
      expression: "formData.typeName"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "项目代码",
      "label-width": _vm.formLabelWidth,
      prop: "typeCode"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      width: "100%"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "calc(50% - 40x)",
      "margin-right": "8px"
    },
    attrs: {
      placeholder: "选择分组",
      clearable: ""
    },
    model: {
      value: _vm.typeCode1,
      callback: function callback($$v) {
        _vm.typeCode1 = $$v;
      },
      expression: "typeCode1"
    }
  }, _vm._l(["a", "b", "c", "d", "e", "f"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1), _c("el-select", {
    staticStyle: {
      width: "calc(50% - 40x)"
    },
    attrs: {
      placeholder: "选择值",
      clearable: ""
    },
    model: {
      value: _vm.typeCode2,
      callback: function callback($$v) {
        _vm.typeCode2 = $$v;
      },
      expression: "typeCode2"
    }
  }, _vm._l(["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1)])], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "项目分组",
      "label-width": _vm.formLabelWidth,
      prop: "typeGroup"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入项目分组"
    },
    model: {
      value: _vm.formData.typeGroup,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "typeGroup", $$v);
      },
      expression: "formData.typeGroup"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "项目类别",
      "label-width": _vm.formLabelWidth,
      prop: "typeCategory"
    }
  }, _vm._l(_vm.typeCategory, function (item, key) {
    return _c("el-radio", {
      key: key,
      staticStyle: {
        "line-height": "40px"
      },
      attrs: {
        label: key
      },
      model: {
        value: _vm.formData.typeCategory,
        callback: function callback($$v) {
          _vm.$set(_vm.formData, "typeCategory", $$v);
        },
        expression: "formData.typeCategory"
      }
    }, [_vm._v(_vm._s(item))]);
  }), 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "计量单位",
      "label-width": _vm.formLabelWidth,
      prop: "unit"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入计量单位"
    },
    model: {
      value: _vm.formData.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "unit", $$v);
      },
      expression: "formData.unit"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "预测参数",
      "label-width": _vm.formLabelWidth,
      prop: "predictionCode"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Nothing"
    },
    model: {
      value: _vm.formData.predictionCode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "predictionCode", $$v);
      },
      expression: "formData.predictionCode"
    }
  }, [_vm._v("无")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "T"
    },
    model: {
      value: _vm.formData.predictionCode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "predictionCode", $$v);
      },
      expression: "formData.predictionCode"
    }
  }, [_vm._v("T")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "DO"
    },
    model: {
      value: _vm.formData.predictionCode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "predictionCode", $$v);
      },
      expression: "formData.predictionCode"
    }
  }, [_vm._v("DO")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "PH"
    },
    model: {
      value: _vm.formData.predictionCode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "predictionCode", $$v);
      },
      expression: "formData.predictionCode"
    }
  }, [_vm._v("PH")])], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "交互协议",
      "label-width": _vm.formLabelWidth,
      prop: "interactiveProtocol"
    }
  }, [_c("el-radio-group", {
    on: {
      input: _vm.radioChange
    },
    model: {
      value: _vm.formData.interactiveProtocol,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "interactiveProtocol", $$v);
      },
      expression: "formData.interactiveProtocol"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Modbus_RTU"
    }
  }, [_vm._v("Modbus RTU")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "JSON"
    }
  }, [_vm._v("JSON")])], 1)], 1)], 1), _vm.formData.interactiveProtocol === "Modbus_RTU" ? _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "从机地址",
      "label-width": _vm.formLabelWidth,
      prop: "slave"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入从机地址"
    },
    model: {
      value: _vm.formData.slave,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "slave", $$v);
      },
      expression: "formData.slave"
    }
  })], 1)], 1) : _vm._e()], 1), _vm.formData.interactiveProtocol === "Modbus_RTU" ? _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "取值起始",
      "label-width": _vm.formLabelWidth,
      prop: "valueStartLocation"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      autocomplete: "off",
      placeholder: "请输入取值起始位置"
    },
    model: {
      value: _vm.formData.valueStartLocation,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueStartLocation", $$v);
      },
      expression: "formData.valueStartLocation"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "取值结束",
      "label-width": _vm.formLabelWidth,
      prop: "valueEndLocation"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      autocomplete: "off",
      placeholder: "请输入取值结束位置"
    },
    model: {
      value: _vm.formData.valueEndLocation,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueEndLocation", $$v);
      },
      expression: "formData.valueEndLocation"
    }
  })], 1)], 1)], 1) : _vm._e(), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "取值类型",
      "label-width": _vm.formLabelWidth,
      prop: "valueType"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.interactiveProtocol == "JSON",
      label: "Integer"
    },
    model: {
      value: _vm.formData.valueType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueType", $$v);
      },
      expression: "formData.valueType"
    }
  }, [_vm._v("整数")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.interactiveProtocol == "JSON",
      label: "Long"
    },
    model: {
      value: _vm.formData.valueType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueType", $$v);
      },
      expression: "formData.valueType"
    }
  }, [_vm._v("长整形")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.interactiveProtocol == "JSON",
      label: "Float"
    },
    model: {
      value: _vm.formData.valueType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueType", $$v);
      },
      expression: "formData.valueType"
    }
  }, [_vm._v("浮点数")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.interactiveProtocol == "Modbus_RTU",
      label: "Number"
    },
    model: {
      value: _vm.formData.valueType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueType", $$v);
      },
      expression: "formData.valueType"
    }
  }, [_vm._v("数值型")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "String"
    },
    model: {
      value: _vm.formData.valueType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueType", $$v);
      },
      expression: "formData.valueType"
    }
  }, [_vm._v("字符串")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.interactiveProtocol == "JSON",
      label: "Integer_Offset"
    },
    model: {
      value: _vm.formData.valueType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueType", $$v);
      },
      expression: "formData.valueType"
    }
  }, [_vm._v("整数偏移")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Enums"
    },
    model: {
      value: _vm.formData.valueType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueType", $$v);
      },
      expression: "formData.valueType"
    }
  }, [_vm._v("枚举")])], 1)], 1)], 1), _vm.formData.valueType == "Enums" ? _c("el-form-item", {
    attrs: {
      label: "值枚举",
      "label-width": _vm.formLabelWidth,
      prop: "valueEnums"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.valueEnumsAdd
    }
  }, [_vm._v("添加")]), _vm._l(_vm.valueEnums, function (item, index) {
    return _c("div", {
      key: index,
      staticStyle: {
        display: "flex",
        "margin-top": "12px",
        "align-items": "center"
      }
    }, [_c("el-input", {
      staticStyle: {
        width: "150px",
        "margin-right": "20px"
      },
      attrs: {
        autocomplete: "off",
        placeholder: "请输入"
      },
      model: {
        value: item.label,
        callback: function callback($$v) {
          _vm.$set(item, "label", $$v);
        },
        expression: "item.label"
      }
    }), _c("el-input", {
      staticStyle: {
        width: "150px",
        "margin-right": "20px"
      },
      attrs: {
        autocomplete: "off",
        placeholder: "请输入"
      },
      model: {
        value: item.value,
        callback: function callback($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    }), _c("el-button", {
      attrs: {
        size: "mini"
      },
      on: {
        click: function click($event) {
          return _vm.valueEnumsDel(index);
        }
      }
    }, [_vm._v("删除")])], 1);
  })], 2) : _vm._e(), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_vm.formData.valueType == "Float" ? _c("el-form-item", {
    attrs: {
      label: "浮点计算模式",
      "label-width": _vm.formLabelWidth,
      prop: "endianMode"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.valueType == "Float" && _vm.formData.interactiveProtocol == "JSON",
      label: "LITTLE_ENDIAN"
    },
    model: {
      value: _vm.formData.endianMode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "endianMode", $$v);
      },
      expression: "formData.endianMode"
    }
  }, [_vm._v("小端")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.valueType == "Float" && _vm.formData.interactiveProtocol == "JSON",
      label: "BIG_ENDIAN"
    },
    model: {
      value: _vm.formData.endianMode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "endianMode", $$v);
      },
      expression: "formData.endianMode"
    }
  }, [_vm._v("大端")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.valueType == "Float" && _vm.formData.interactiveProtocol == "JSON",
      label: "ASCII"
    },
    model: {
      value: _vm.formData.endianMode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "endianMode", $$v);
      },
      expression: "formData.endianMode"
    }
  }, [_vm._v("ASCII")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.valueType == "Float" && _vm.formData.interactiveProtocol == "JSON",
      label: "CDAB"
    },
    model: {
      value: _vm.formData.endianMode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "endianMode", $$v);
      },
      expression: "formData.endianMode"
    }
  }, [_vm._v("CDAB")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      disabled: _vm.formData.valueType == "Float" && _vm.formData.interactiveProtocol == "JSON",
      label: "CDAB_IEEE754"
    },
    model: {
      value: _vm.formData.endianMode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "endianMode", $$v);
      },
      expression: "formData.endianMode"
    }
  }, [_vm._v("CDAB IEEE754")])], 1) : _vm._e()], 1)], 1), _vm.formData.valueType == "Integer_Offset" ? _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "偏移开始",
      "label-width": _vm.formLabelWidth,
      prop: "valueStartLocationFractional"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      autocomplete: "off",
      placeholder: "请输入小数取值起始位置"
    },
    model: {
      value: _vm.formData.valueStartLocationFractional,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueStartLocationFractional", $$v);
      },
      expression: "formData.valueStartLocationFractional"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "偏移结束",
      "label-width": _vm.formLabelWidth,
      prop: "valueEndLocationFractional"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      autocomplete: "off",
      placeholder: "请输入小数取值结束位置"
    },
    model: {
      value: _vm.formData.valueEndLocationFractional,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueEndLocationFractional", $$v);
      },
      expression: "formData.valueEndLocationFractional"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.formData.valueType == "Integer" || _vm.formData.valueType == "Long" || _vm.formData.valueType == "Float" || _vm.formData.valueType == "Number" ? _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "倍增量",
      "label-width": _vm.formLabelWidth,
      prop: "valueMultiply"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      autocomplete: "off",
      placeholder: "请输入倍增量"
    },
    model: {
      value: _vm.formData.valueMultiply,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueMultiply", $$v);
      },
      expression: "formData.valueMultiply"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "偏移量",
      "label-width": _vm.formLabelWidth,
      prop: "valueOffset"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      autocomplete: "off",
      placeholder: "请输入偏移量"
    },
    model: {
      value: _vm.formData.valueOffset,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueOffset", $$v);
      },
      expression: "formData.valueOffset"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.formData.interactiveProtocol == "JSON" ? _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "取值路径",
      "label-width": _vm.formLabelWidth,
      prop: "valuePath"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "值路径"
    },
    model: {
      value: _vm.formData.valuePath,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valuePath", $$v);
      },
      expression: "formData.valuePath"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "时间路径",
      "label-width": _vm.formLabelWidth,
      prop: "valueTimePath"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "值对应时间路径"
    },
    model: {
      value: _vm.formData.valueTimePath,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "valueTimePath", $$v);
      },
      expression: "formData.valueTimePath"
    }
  })], 1)], 1)], 1) : _vm._e(), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "排序号",
      "label-width": _vm.formLabelWidth,
      prop: "sort"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      type: "number",
      placeholder: "排序号"
    },
    model: {
      value: _vm.formData.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "sort", $$v);
      },
      expression: "formData.sort"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "匹配长度",
      "label-width": _vm.formLabelWidth,
      prop: "matchLength"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      type: "number",
      placeholder: "匹配长度"
    },
    model: {
      value: _vm.formData.matchLength,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "matchLength", $$v);
      },
      expression: "formData.matchLength"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "备注",
      "label-width": _vm.formLabelWidth,
      prop: "remark"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      maxlength: "2000"
    },
    model: {
      value: _vm.formData.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "remark", $$v);
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.closeEditDialogShow
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitFormData
    }
  }, [_vm._v("确 定")])], 1)], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };